export const sharedMailboxApiPaths = {
  sharedMailboxes: '/shared-mailboxes',
  sharedMailbox: (id: string) => `/shared-mailboxes/${id}`,
  connectionTests: '/shared-mailbox-connection-tests'
};

/** A tenant has a handful of inboxes; one page holds them all. */
export const SHARED_MAILBOX_PAGE_SIZE = 500;
